import appMode from '../appMode';
import { appStatuses, updateStatuses, imageCreationStatuses, cloneCreationStatuses, licenceStatuses } from '../statuses';
import Licence from '../models/Licence';
import workflowStatus from '../workflowStatus';
import NotificationCollection from '../notification/notificationCollection';

const defaultDate = new Date('2016-01-01');

/**
 * A common format for storing update status, time and any related error in a common format, thus allowing the UI to render differently while waiting for data.
 * See updateableReducer for help writing the reducer.
 */
const updateable = initialValue => ({
        value: initialValue,
        valueUpdateTime: defaultDate,
        statusUpdateTime: defaultDate,
        updateStatus: updateStatuses.initial,
        totalCount: null,
        currentError: {
                userMessage: '',
                technicalContext: ''
        }
});

export default {
    sqlServerInstances: updateable(new Map()), //Map of instance location id to instance details
    instanceDetails: new Map(), 
    imageDestinationLocations: updateable(new Map()), 
    backupLocations: updateable(new Map()), 
    images: updateable(new Map()),
    operationProgress: updateable(new Map()),
    clones: updateable(new Map()),
    agents: updateable(new Map()),
    operations: updateable(new Map()),
    users: {
        me: updateable({})
    },
    permissions: updateable({}),
    app: {
        status: appStatuses.initiating,
        licence: updateable(new Licence(licenceStatuses.none)),
        mode: appMode.manage,
        notifications: new NotificationCollection(),
        shouldShowGettingStarted: true,
        imageCreation: {
                workflowStatus: workflowStatus.initial,
                imageName: '',
                imageType: 'vhd',
                source: '',
                sourceLocation: {
                    id: '',
                    friendlyName: '',
                    resourceNames: []
                },
                destinationLocation: {
                    id: '',
                    friendlyName: '',
                    resourceNames: []
                },
                operation: {
                    status: imageCreationStatuses.initial,
                    id: ''
                }
        },
        cloneCreation: {
            workflowStatus: workflowStatus.initial,
            source: '',
            destination: {
                id: '',
                friendlyName: '',
                resourceNames: []
            },
            operation: {
                status: cloneCreationStatuses.initial,
                id: ''
            }
        }
    },
    tour: {
        dashboard: true,
		imageCreate: true,
		imageSource: true
    }
};



// WEBPACK FOOTER //
// ./src/js/reducers/initialState.js